import { render, staticRenderFns } from "./FHomePanter.vue?vue&type=template&id=2c45f60e&scoped=true&"
import script from "./FHomePanter.vue?vue&type=script&lang=js&"
export * from "./FHomePanter.vue?vue&type=script&lang=js&"
import style0 from "./FHomePanter.vue?vue&type=style&index=0&id=2c45f60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45f60e",
  null
  
)

export default component.exports